<template>
  <div class="flex flex-col gap-8">
    <router-view name="navigation" />
    <router-view />
  </div>
</template>
